export const TOAST_SEVERITY = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
} as const;

export type ToastSeverity = typeof TOAST_SEVERITY[keyof typeof TOAST_SEVERITY];

export const TOAST_CONFIG = {
  AUTO_HIDE_DURATION_MS: 4000,
  ANCHOR_VERTICAL: 'top',
  ANCHOR_HORIZONTAL: 'center',
} as const;

export const TOAST_CLOSE_REASON = {
  CLICKAWAY: 'clickaway',
} as const;
